const MEASUREMENT_ID = "G-0YZKGNJXSV";

export function gaConfig(data) {
  window.gtag("set", data);
  if (process.env.REACT_APP_ENV === "dev") {
    window.gtag("config", MEASUREMENT_ID, {
      ...data,
    });
  } else {
    window.gtag("config", MEASUREMENT_ID, {
      ...data,
      debug_mode: true,
    });
  }
}

export function gaEvent(action, category, description, id) {
  window.gtag("event", action, {
    category: category,
    label: description,
    ...(id && { [`${category}_id`]: id }),
  });
}
